<template>

    <tab-list v-if="scope">
        <tab v-for="section in scope.children" v-if='section.type === "scope_of_works_section"' :key="section.id" :name="section.title">
            <sow-looper :items="section.children" v-if="section.children.length"></sow-looper>
        </tab>
    </tab-list>

</template>

<script>
    export default {
        props: ['scopeId'],
        data() {
            return {
                name: 'scopeofworks',
                scope: null
            }
        },
        methods: {
            getScope() {
                this.scope = null;
                var that = this;
                var url = appUrls.sow.show.replace('REPLACEME', this.scopeId);

                axios.get(url).then(response => {
                    that.scope = response.data.data;
                });
            }
        },
        mounted() {
            this.getScope();
        }
    }
</script>

<style lang="scss">

</style>
